/**
 * Performance optimizer for lazy loading slideshows
 * Uses Intersection Observer to defer loading of below-fold content
 */

class PerformanceOptimizer {
  constructor() {
    this.init();
  }

  init() {
    // Only run if Intersection Observer is supported
    if (!('IntersectionObserver' in window)) {
      return;
    }

    this.setupSlideshowLazyLoading();
    this.setupImageLazyLoading();
  }

  setupSlideshowLazyLoading() {
    const lowPrioritySlideshows = document.querySelectorAll('[data-section-type="slideshow-section"] .hero[data-slide-count]');
    
    if (lowPrioritySlideshows.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadSlideshow(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '100px 0px' // Start loading 100px before entering viewport
    });

    // Observe slideshows that should be lazy loaded
    lowPrioritySlideshows.forEach((slideshow, index) => {
      // Skip first slideshow (keep it eager)
      if (index > 0) {
        observer.observe(slideshow);
      }
    });
  }

  setupImageLazyLoading() {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]:not([src])');
    
    if (lazyImages.length === 0) return;

    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imageObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px 0px'
    });

    lazyImages.forEach((img) => {
      imageObserver.observe(img);
    });
  }

  loadSlideshow(slideshow) {
    // Add loaded class to trigger any CSS animations
    slideshow.classList.add('slideshow-loaded');
    
    // Force any lazy images within to start loading
    const lazyImages = slideshow.querySelectorAll('img[loading="lazy"]');
    lazyImages.forEach((img) => {
      if (img.dataset.src && !img.src) {
        img.src = img.dataset.src;
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PerformanceOptimizer();
  });
} else {
  new PerformanceOptimizer();
}